var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"disabled":_vm.disabled}},[_c('b-form-select',{attrs:{"options":_vm.get_options_simple('provider')},model:{value:(_vm.model.provider_id),callback:function ($$v) {_vm.$set(_vm.model, "provider_id", $$v)},expression:"model.provider_id"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }